export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de procesos"])},
          "containers_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "packages_from_stock_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cajas disponibles"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "total_number_containers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contenedores"])},
          "total_packages_from_stock": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cajas disponibles"])}
        }
      }
    }
  })
}